// Allocation (C.1/C.2a/C.4) API types — mirror the backend Pydantic models.

export type GateStatus = "ok" | "blocked" | "stale";

export interface GateStatusOut {
  status: GateStatus;
  reason: string;
  latest_run_id: string | null;
}

export interface ProvenanceFields {
  source: string;
  source_ref: string | null;
  inventory_slug: string | null;
  import_run_id: string | null;
  label: string | null;
  created_at: string;
}

export interface DhcpNode {
  id: string;
  range_start: string | null;
  range_end: string | null;
}

export interface VlanNode extends ProvenanceFields {
  id: string;
  cidr: string | null;
  vlan_tag: number | null;
  dhcp_ranges: DhcpNode[];
}

export interface SiteNode extends ProvenanceFields {
  id: string;
  cidr: string | null;
  site_id: string | null;
  site_slug: string | null;
  vlans: VlanNode[];
}

export interface AccountNode extends ProvenanceFields {
  id: string;
  cidr: string | null;
  account_id: string | null;
  account_slug: string | null;
  sites: SiteNode[];
}

export interface PreviewOut {
  cidr: string | null;
  gate_status: string;
}

export interface AllocationOut {
  id: string;
  kind: string;
  cidr: string | null;
  range_start?: string | null;
  range_end?: string | null;
  parent_id?: string | null;
}

export interface VlanTemplateOut {
  vlan_tag: number;
  name: string;
  prefix_len: number;
  offset_units: number;
  dhcp_enabled: boolean;
  optional: boolean;
  ord: number;
}

export interface VlanGenerationOut {
  results: Array<Record<string, unknown>>;
}

export interface ImportRunSummary {
  id: string;
  status: string;
  created_at: string;
  counts?: Record<string, number>;
}

export interface ImportRunOut extends ImportRunSummary {
  // Backend serializes the conflict report as a JSONB dict: { findings: [...] }.
  report?: { findings?: Array<Record<string, unknown>> };
}

export interface AllocateAccountIn {
  market_pool: string;
  account_slug?: string;
  label?: string;
}

export interface AllocateSiteIn {
  site_slug: string;
  label?: string;
}

export interface VlanGenerateIn {
  vlan_tags: number[];
}

// The only seeded market pool today (migration 011: 10.128.0.0/12). market_pool
// is REQUIRED by POST /allocations/accounts and is NOT derivable from account_kind.
// If a markets endpoint is added later, source this from it instead.
export const KNOWN_MARKET_POOLS: ReadonlyArray<{ value: string; label: string }> = [
  { value: "pakistan_residential", label: "Pakistan residential" },
];
